//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('usersFilterDropdown', {
    bindings: {
      userIds: '<',
      contentGroup: '<',
    },
    transclude: true,
    template: require('@legacy-components/filters/users-filter-dropdown.html'),
    controller: [
      'ContentLibrarySearchFilterHelper',
      'SEARCH_FILTERS',
      'SearchFilterService',
      function(
                ContentLibrarySearchFilterHelper,
                SEARCH_FILTERS,
                SearchFilterService,
            ) {
        const self = this;
        self.SEARCH_FILTER_SET_NAME = SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS;
        self.state = {
          userIds: [],
          contentGroup: [],
        };
        self.isLoading = true;

        self.usersFilterReadyCallback = function() {
          self.isLoading = false;
        };

        self.$onChanges = function(changesObj) {
          if (changesObj.userIds) {
            self.state.userIds = changesObj.userIds.currentValue;
          }
          if (changesObj.contentGroup) {
            self.state.contentGroup = changesObj.contentGroup.currentValue;
          }
        };

        const updateUserDropdownLabel = function(setObject) {
          self.userDropdownLabel = ContentLibrarySearchFilterHelper.userDropdownOptionsFromFilters(setObject);
        };

        self.$onInit = function() {
          SearchFilterService.getObservableForFilterSet(
                        SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
                    ).map(setUpdate => setUpdate.setObject).subscribe((setUpdate) => {
                      updateUserDropdownLabel(setUpdate);
                    });
        };
      },
    ],
  });
})();
